import { useState } from "react";
import Breadcrumb from '../../components/Breadcrumbs';
import MultiManual from '../../components/Manual/MultiManual';
import ServiceOrderRegister from "./ServiceOrderRegister";

export default function ServiceOrder() {

    const [refresh, setRefresh] = useState(true);

    return (
        <>
            <div style={{ marginTop: 32, marginLeft: 20 }}>
                <Breadcrumb
                    paths={[
                        { href: '/my-service-orders', name: 'Ocorrências Internas' },
                        { href: '', name: 'Criar Ocorrência Interna' },
                    ]}
                />
            </div>

            <ServiceOrderRegister refresh={refresh} setRefresh={setRefresh} />

            <MultiManual
                components={[
                    {
                        id: 'form-inputs',
                        message: 'Você pode preencher este formulário com os dados de uma nova ocorrência interna',
                        rect: { height: 20, top: 100 }
                    },
                    {
                        id: 'register-button',
                        message: 'Aperte o botão para confirmar o cadastro',
                        rect: { height: 20 }
                    }
                ]}
            />
        </>
    )
}
